import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { memoizeFunction } from '@fluentui/react/lib/Utilities';
import { dataUniqueId } from '@ms/acui-common';
import { AppThemeConsumer } from '@ms/acui-theme';
import { getAppLinkClassNames } from './AppLink.classNames';
var AppLink = /** @class */ (function (_super) {
    __extends(AppLink, _super);
    function AppLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getLinkPropsFromUrlDetails = memoizeFunction(function (urlDetails) {
            var _a;
            // attribute: href
            var linkProps = {
                href: urlDetails.href,
                target: urlDetails.target,
            };
            var trimmedDownloadLink = (_a = urlDetails.download) === null || _a === void 0 ? void 0 : _a.trim();
            if (trimmedDownloadLink) {
                linkProps.download = trimmedDownloadLink;
            }
            return linkProps;
        });
        return _this;
    }
    AppLink.prototype.render = function () {
        var _this = this;
        var _a = this.props, handler = _a.handler, onExecute = _a.onExecute, text = _a.text, type = _a.type, restProps = __rest(_a, ["handler", "onExecute", "text", "type"]);
        // VSO 4135190: remove this check for href once we move handler to be type UrlDetails only
        var linkProps = (handler === null || handler === void 0 ? void 0 : handler.hasOwnProperty('href'))
            ? // VSO 4135190: remove casting as part of refactoring
                this.getLinkPropsFromUrlDetails(handler)
            : {
                onClick: 
                // VSO 4135190: pass only onExecute as part of refactoring once onExecute is consumed
                onExecute ||
                    handler,
                href: '#',
            };
        return (React.createElement(AppThemeConsumer, null, function (theme) {
            var classNames = getAppLinkClassNames(theme);
            return (React.createElement("a", __assign({}, linkProps, restProps, { role: _this.props.role, "data-unique-id": dataUniqueId(_this.props), className: classNames.root }), text));
        }));
    };
    return AppLink;
}(React.PureComponent));
export { AppLink };
//# sourceMappingURL=AppLink.js.map